export enum PlanningOrderStatus {
  CURRENT_PLAN = "CURRENT_PLAN",
  POTENTIAL_PLAN = "POTENTIAL_PLAN",
  ORDER = "ORDER",
  PROPOSED_POTENTIAL_PLAN = "PROPOSED_POTENTIAL_PLAN",
}
